

module.exports = __webpack_require__.stylable.create(
    "BuyerNoteSectionOverride3302437623",
    {"classes":{"root":"BuyerNoteSectionOverride3302437623__root","noteTitle":"BuyerNoteSectionOverride3302437623__noteTitle","noteText":"BuyerNoteSectionOverride3302437623__noteText"},"vars":{},"stVars":{"titleTextColor":"'\"color(--thankYou_textColor)\"'","titleTextFont":"'\"font({theme: 'thankYou_textFontStyle', size: '14px', lineHeight: '20px'})\"'","textColor":"'\"opacity(--thankYou_infoTextColor, 0.6)\"'","textFont":"'\"font({theme: 'thankYou_infoTextFontStyle', size: '14px', lineHeight: '20px'})\"'"},"keyframes":{}},
    "",
    14,
    "BuyerNoteSectionOverride3302437623",
    null
);
